export default "__VITE_ASSET__BPvcBJQ1__"